import { render, staticRenderFns } from "./AddressListView.vue?vue&type=template&id=1f2cc30f&scoped=true"
import script from "./AddressListView.vue?vue&type=script&lang=js"
export * from "./AddressListView.vue?vue&type=script&lang=js"
import style0 from "./AddressListView.vue?vue&type=style&index=0&id=1f2cc30f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2cc30f",
  null
  
)

export default component.exports